import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=f8c62fb2&scoped=true&"
import script from "./CardImage.vue?vue&type=script&lang=js&"
export * from "./CardImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c62fb2",
  null
  
)

export default component.exports